import React from 'react';
import Icone from '../util/Icone';
import { faArrowRight } from '../util/icones';
import imagem1 from "../../assets/1.webp";

const Diagnostic = () => {
  return (
    <section className="grid xl:grid-cols-[5fr_3fr] xl:items-center xl:pt-24 pb-12 mb-4">
      <div className="xl:col-start-2 xl:row-start-1 xl:self-end z-10">
        <p className="text-sm font-semibold uppercase tracking-widest text-pattern-dark mb-4">Diagnóstico</p>
        <h3 className="text-2xl xl:text-4xl font-semibold leading-tight mb-6">
          Encontramos o gargalo no processo antes que ele chegue ao cliente
        </h3>
      </div>

      <div className="xl:col-start-1 xl:row-start-1 xl:row-span-2 xl:self-center flex justify-center xl:justify-start mb-10 xl:mb-0">
        <img
          src={imagem1}
          alt="Celular flutuando sobre um fundo azul, exibindo gráficos de análise de dados."
          width="500"
          height="500"
          loading="lazy"
          className="max-w-full h-auto aspect-square"
        />
      </div>

      <div className="xl:col-start-2 xl:row-start-2 xl:self-start z-10">
        <p className="text-xl leading-relaxed">
          Visitamos a sua empresa, mapeamos os processos no dia a dia e entregamos um plano claro do que automatizar primeiro.
        </p>
        <a href="/diagnostico-de-processos" className="inline-flex items-center gap-2 font-semibold text-pattern-dark hover:underline mt-6">
          Como funciona o diagnóstico
          <Icone icon={faArrowRight} className="text-sm" />
        </a>
      </div>
    </section>
  );
};

export default Diagnostic;
